import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../utils';
// constant
import { FORM_REFS } from '../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../restClient';
// children
import { Entity } from '../../../utils/Models';
import Dynamicform from '../../common/Dynamicform/dynamicForm';
import { DuplicateEntityModal } from '../Modals';
//action Creator
import { hideActionButton } from '../../layouts/actions/actionCreator';
import { createEntity, updateEntity } from '../actions/actionCreator';
//style
import './CreateNewEntity.css';

const CreateNewEntity = (props) => {
  const [formJson, setFormJson] = useState();
  const [formData, setFormData] = useState({});
  const [showDuplicateEntityModalDialog, setShowDuplicateEntityModalDialog] = useState(false);
  const [modalProps, setModalProps] = useState({});
  const [duplicatePagejson, setDuplicatePagejson] = useState({});
  const [conflictedEntity, setConflictedEntity] = useState(undefined);
  const locationState = props.history.location.state;

  useEffect(() => {
    let apiUrl = "/aemData/formData/json_create-entity";
    if (props.mode === "edit") {
      apiUrl = apiUrl.replace("create-entity", "edit-entity");
    }
    (async () => {
      const { data } = await aemHostClient(apiUrl);
      document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, props.lang.currentLang.lang, props.lang.translatedData)} - ${'HSBC GLCM'}`;
      setFormJson(data)
    })();

    (async () => {
      const { data } = await aemHostClient('/aemData/formData/json_duplicate-entity');
      setDuplicatePagejson(data)
    })();
    return () => {
      // Anything in here is fired on component unmount.
    }
  }, []);

  useEffect(() => {
    if (props.history.location.pathname.includes("/create-a-case/")) {
      props.hideCrumbs();
    }
    props.hideActionButton();
  }, []);


  const getFormData = (formData) => {
    if (formData.glcmImplementation !== undefined && formData.glcmImplementation === false) {
      formData.projectNo = ''; // To not pass any value for projectNo (CS or CMP) in the payload; also helps to empty the radio selection when GPS Implementation is set to No (false)
      formData.csProjectNumber = '';
      formData.cmpProjectID = '';
      //delete formData['csProjectNumber'];
    }
    setFormData(formData)
  }

  const toggleDialog = () => {
    setShowDuplicateEntityModalDialog(false)
  }

  const _onUseExisting = () => {
    setShowDuplicateEntityModalDialog(false)
    eapiClient('/cases/' + conflictedEntity.id + '/checkStatus')
      .then(({ data }) => {
        props.createEntity(new Entity({ ...conflictedEntity, status: data.responseData.status, gdocsTerms: data.responseData.gdocsTerms }));
        props.history.goBack();
      });
  }

  const _onAmendDetails = () => {
    setShowDuplicateEntityModalDialog(false)
    // this.setState({ showDuplicateEntityModalDialog: false });
    // eapiClient("/entities/organisations/" + conflictedEntity.id, {
    //   method: 'PUT',
    //   data: JSON.stringify({basicDetails: {...formData, entityId: conflictedEntity.id}})
    // })
    // .then(({data, status}) => {
    //   data.responseData.status = 'no_conflicts';
    //   props.createEntity(new Entity(data.responseData));
    //   props.history.goBack();
    // });
  }

  const onFormSubmit = (event, apiUrl) => {

    var requestData = formData;

    if (props.mode === 'edit') {
      apiUrl = apiUrl + "/" + formData.id;
      requestData = { basicDetails: { ...formData } };
    }
    if (formData.csProjectNumber !== '' && formData.csProjectNumber !== undefined) {
      let _csProjectNumber = 'PRJ_' + formData.csProjectNumber
      if (props.mode === 'edit') {
        requestData = {
          ...requestData.basicDetails,
          csProjectNumber: _csProjectNumber
        }
      } else {
        requestData = {
          ...requestData,
          csProjectNumber: _csProjectNumber
        }
      }
    }
    if (formData.cmpProjectID !== '' && formData.cmpProjectID !== undefined) {
      let _cmpProjectID = 'P' + formData.cmpProjectID
      if (props.mode === 'edit') {
        requestData = {
          ...requestData.basicDetails,
          cmpProjectID: _cmpProjectID
        }
      } else {
        requestData = {
          ...requestData,
          cmpProjectID: _cmpProjectID
        }
      }
    }
    let METHOD = props.mode === 'edit' ? 'PUT' : 'POST';
    (async () => {
      try {
        const { data } = await eapiClient(apiUrl, {
          method: METHOD,
          data: JSON.stringify(requestData)
        });
        if (props.mode !== "edit") {
          data.responseData.status = 'no_conflicts';
          data.responseData.gdocsTerms = 'New to GDocs'
          props.createEntity(new Entity(data.responseData));
          // props.history.push("/create-a-case/select-entity");
          /*Reusing same page for case-body add customer so using goBack*/
          props.history.goBack();
        } else if (props.mode === "edit") {
          props.updateEntity(data.responseData.id, data.responseData);
          props.history.goBack();
        }
      } catch (error) {
        if (error && error.response && error.response.status === 409) {
          const modalProps = {
            registeredName: formData.registeredName,
            duplicateentitymodal: duplicatePagejson.par.modal_duplicateEntity,
            cof: formData.countryOfIncorporation.name
          }
          setShowDuplicateEntityModalDialog(true)
          setModalProps(modalProps)
          setConflictedEntity(error.response.data.responseData)
        }
      }
    })();
  }

  const onFormCancel = () => {
    props.history.goBack();
  }

  const renderFormGroups = () => {
    let formData;
    if (props.currentEntity !== undefined) {
      formData = { ...props.currentEntity };

    } else {
      formData = {};
    }
    const properties = {
      entityId: locationState.entityId,
      registeredName: locationState.newEntityName,
      formData,
      editType: 'entity',
      pathname: props.history.location.pathname,
      bankingNonBankingHelpTextModal: true
    };
    if (formJson !== undefined && formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform
          mode={props.mode}
          properties={properties}
          url={FORM_REFS[formJson.par.aemform_.formRef]}
          getFormData={getFormData}
          onFormSubmit={onFormSubmit}
          onFormCancel={onFormCancel}
          disableSubmitOnClick={false}
          lang={props.lang.currentLang.lang}
          translatedData={props.lang.translatedData}
          flag={props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  const translations = (word) => {
    return Translations(word, props.lang.currentLang.lang, props.lang.translatedData)
  }


  const pageTitle = formJson ? formJson['par'].page_title_mainTitle : '';
  const containerCss = classnames("create-new-entity", {
    "padding-40": !props.history.location.pathname.includes("/create-a-case/")
  });
  return (
    <div className={containerCss}>
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">{translations(pageTitle.pageHeading)}</h2>
          <p className="form-required-desc">{translations(pageTitle.descriptionText)}</p>
        </div>
        {renderFormGroups()}
      </div>
      <DuplicateEntityModal
        showDialog={showDuplicateEntityModalDialog}
        {...modalProps}
        toggleDialog={toggleDialog}
        _onUseExisting={_onUseExisting}
        _onAmendDetails={_onAmendDetails}
        bsClass="duplicate-entity-modal-content"
        lang={props.lang}
        translations={(word) => translations(word)}
      />
    </div>
  )
}


const mapStateToProps = (state, props) => {
  let currentEntity = undefined;
  if (props.location.state) {
    var { mode, entityId } = props.location.state;
    if (mode === 'edit' && entityId && state.entities[entityId]) {
      currentEntity = state.entities[entityId];
    }
  }
  return {
    currentEntity,
    mode: currentEntity !== undefined ? 'edit' : '',
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    hideActionButton: () => {
      dispatch(hideActionButton())
    },
    createEntity: _case => {
      dispatch(createEntity(_case))
    },
    updateEntity: (entityId, updatedEntity) => {
      dispatch(updateEntity(entityId, updatedEntity))
    }
  }
}

CreateNewEntity.propTypes = {
  lang: PropTypes.object,
  currentEntity: PropTypes.object,
  history: PropTypes.object,
  updateEntity: PropTypes.func,
  createEntity: PropTypes.func,
  hideActionButton: PropTypes.func,
  hideCrumbs: PropTypes.func,
  mode: PropTypes.string,

};

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewEntity);



// WEBPACK FOOTER //
// ./src/components/createAcase/SelectEntity/CreateNewEntity.js